import Swiper from "swiper";
import { api } from "../API";

export default {
  init() {
    this._setupSearchForm();

    const categories = $("#support_categories");
    const subCategories = $("#support_sub_categories");
    const searchCategoryBtn = $(".support-category-select a.search-button");
    const subCategoriesSwiper = $(".subs-swiper");

    categories.specialSelect().init({
      onSelect: function(value) {
        subCategories.specialSelect().toggleItems("category", value.value);
        subCategories.specialSelect().clearSelection();
        subCategories.specialSelect().showElement();
      }
    });

    subCategories.specialSelect().init({
      onSelect: function(value) {
        const url = value.url;
        const newTarget = value.blank;

        searchCategoryBtn.attr("href", url);
        searchCategoryBtn.attr("target", newTarget ? "_blank" : "_self");

        searchCategoryBtn.addClass("active");
      }
    });

    subCategories.specialSelect().hideSelections();
    subCategories.specialSelect().hideElement();

    $(window).on("load", () => {
      subCategoriesSwiper.each(function(idx, elem) {
        let subsSwiper = new Swiper($(elem).find(".sub-categories-swiper"), {
          slidesPerView: 4,
          spaceBetween: 14,
          navigation: {
            nextEl: $(elem).find(".swiper-button-next"),
            prevEl: $(elem).find(".swiper-button-prev")
          },
          breakpoints: {
            1200: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 2
            },
            767: {
              slidesPerView: 3.5
            },
            500: {
              slidesPerView: 2.5
            }
          }
        });

        if ($(elem).find(".swiper-wrapper .swiper-slide").length <= 4) {
          $(elem)
            .find(".swiper .swiper-button-next")
            .hide();
        }
      });
    });
  },

  _setupSearchForm() {
    let $form = $(".snow-support-form");
    $form.submit(function(e) {
      e.preventDefault();

      $(".login-modal")
        .modal()
        .show();
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
